<template>
    <v-slide-x-transition>
        <v-card elevation="0" height="4" tile :loading="loading" style="z-index: 100; height: 100vw; width: 100vw">
            <v-card-text>
                <v-row v-if="error">
                    <v-col class="d-flex flex-column justify-center">
                        <span class="text-center">{{ error }}</span>
                        <span class="text-center">clique no botão a baixo para efetuar seu login.</span>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col class="d-flex flex-column justify-center">
                        <span class="text-center">Seu e-mail foi confirmado com sucesso.</span>
                        <span class="text-center">clique no botão a baixo para efetuar seu login.</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="d-flex flex-column justify-center">
                        <span class="text-center"> <v-btn color="green" class="white--text"
                                @click="goToLogin()">{{ $t("header.login") }}</v-btn></span>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-slide-x-transition>
</template>
<script>
import { saveAuthAndRedirect } from '@/services/authService'

export default {
    name: 'AuthConfirmation',
    data() {
        return {
            processing: false,
            loading: true,
            error: null,
        }
    },
    mounted() {
        this.submit()
    },
    methods: {
        goToLogin() {
            this.$router.push('/entrar')
        },
        submit() {
            this.loading = true
            this.$axios.put('users/confirm', { token: this.$route.params.token }).then(
                (response) => {
                    this.processing = false
                    this.loading = false
                    const data = response.data.data

                    if (data.dataMissing) {
                        const links = [`hash=${data.hash}`]
                        if (data.redirect === 'materialUpload')  links.push('step=3')
                        if (data.redirect === 'whitelabel')       links.push('step=4')
                        if (data.redirect === 'company')          links.push('step=2')
                        if (data.redirect === 'termSignature') {
                            links.push(`term=${data.accession.termId}`)
                            links.push(`doc=${data.accession.url}`)
                            links.push('step=5')
                        }
                        if (data.redirect === 'isLegal' || data.redirect === 'confirmLegal') {
                            links.push('step=5')
                        }
                        this.$router.replace(`/cadastrar?${links.join('&')}`)
                        return
                    }

                    // Confirmação retornou dados de sessão — loga automaticamente
                    if (data.security) {
                        saveAuthAndRedirect(data, null)
                        return
                    }

                    // Sem dados de sessão — redireciona para login
                    this.goToLogin()
                },
                (error) => {
                    this.loading = false
                    this.processing = false
                    const errs = error.response?.data?.errors
                    if (!errs?.length || !errs[0]) return
                    const msg = Object.values(errs[0])?.[0]?.[0] ?? ''
                    if (msg === 'Este e-mail já foi confirmado.') {
                        this.error = msg
                    }
                }
            )
        },
    },
}
</script>